import React, { useEffect } from 'react';
import { commonHelpers } from 'utilities/helpers';

interface props {
    label: string;
    value?: any;
    type: string;
    suffix?: string;
    formatNumber?: boolean;
    suffixLinkText?: string;
    onClickLink?: (value: any) => void;
    className?: string;
    roundFunction?: (value: any) => any;
    defaultvalue?: any;
}

export const ItemBox = ({
    label,
    value,
    type,
    suffix,
    formatNumber = true,
    suffixLinkText,
    onClickLink,
    className,
    roundFunction = (value: any) => {
        if (value) {
            return Math.floor(value);
        }
    },
    defaultvalue,
}: props) => {
    const [displayValue, setDisplayValue] = React.useState<any>(value);

    useEffect(() => {
        if (value) {
            if (type === 'number' && formatNumber) {
                const val = roundFunction ? roundFunction(Number(value)) : Number(value);
                setDisplayValue(commonHelpers.formatNumberMoney(val));
            } else if (type === 'date') {
                setDisplayValue(commonHelpers.formatDateWithWeekDay(value));
            } else {
                setDisplayValue(value);
            }
        } else if (defaultvalue !== undefined && defaultvalue !== null && defaultvalue !== '') {
            setDisplayValue(defaultvalue);
        } else if (type === 'number') {
            setDisplayValue(0);
        }
    }, [value]);

    return (
        <>
            <div className={`h-full w-full flex items-center ${className ?? ''}`}>
                <div className="w-fit whitespace-nowrap flex items-center px-[8px] justify-start w-fit h-[40px] text-[14px] leading-[14px] bg-[#ffffff1a] rounded-[2px]">
                    {label}
                </div>
                <div className="flex whitespace-nowrap items-center justify-end h-[40px] px-[8px] text-[20px] text-right bg-[#ffffff1a] rounded-[2px] w-full">
                    {displayValue}
                    {suffix && (
                        <div className="flex items-center justify-end w-fit px-[8px] font-normal text-black text-[14px] text-right leading-[14px] whitespace-nowrap relative tracking-[0]">
                            {suffix}
                        </div>
                    )}
                    {suffixLinkText && (
                        <div
                            onClick={onClickLink}
                            className="flex items-center justify-end w-fit cursor-pointer font-medium text-thirdly text-[12px] leading-[12px] whitespace-nowrap relative tracking-[0]"
                        >
                            {suffixLinkText}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};
